export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_SERVICES = 'SET_SERVICES';